import React, { useState, useEffect } from 'react';
import axios from '../config/axios';
import { gapi } from 'gapi-script';
import '../style/editProfile/editProfile.css';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CLIENT_ID = '1017321138433-knsj6shp6h17gu12osf0qsgq22vd6ope.apps.googleusercontent.com';
const API_SCOPE = 'profile email';
const FACEBOOK_APP_ID = '1171600770946125';

const EditProfile = () => {
  const { t } = useTranslation();
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingBio, setIsEditingBio] = useState(false);
  const [isEditingPhoto, setIsEditingPhoto] = useState(false);
  const [isEditingUsername, setIsEditingUsername] = useState(false);
  const [googleUser, setGoogleUser] = useState(null);
  const [facebookUser, setFacebookUser] = useState(null);
  const [showTwitterLink, setShowTwitterLink] = useState(true);
  const [showLinkedInLink, setShowLinkedInLink] = useState(true);
  const [showThreadsLink, setShowThreadsLink] = useState(true);
  const [showGoogleLink, setShowGoogleLink] = useState(true);
  const [showFacebookLink, setShowFacebookLink] = useState(true);
  const [currentFirstName, setCurrentFirstName] = useState('');
  const [currentMiddleName, setCurrentMiddleName] = useState('');
  const [currentLastName, setCurrentLastName] = useState('');
  const [currentBio, setCurrentBio] = useState('');
  const [currentPhoto, setCurrentPhoto] = useState(null);
  const [currentUsername, setCurrentUsername] = useState('');
  const [currentUrl, setCurrentUrl] = useState('');
  const [currentEmail, setCurrentEmail] = useState('');
  const [originalFirstName, setOriginalFirstName] = useState('');
  const [originalMiddleName, setOriginalMiddleName] = useState('');
  const [originalLastName, setOriginalLastName] = useState('');
  const [originalBio, setOriginalBio] = useState('');
  const [originalUsername, setOriginalUsername] = useState('');
  const [saving, setSaving] = useState(false);
  const [activeSection, setActiveSection] = useState('about');

  const handleEditPhoto = () => {
    setIsEditingPhoto(!isEditingPhoto);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user?.id) return;

    axios.get(`/user/${user.id}/profile`)
    .then(response => {
        const profile = response.data.profile || {};
        const userData = response.data.user || user;
        setCurrentFirstName(userData.firstName || '');
        setOriginalFirstName(userData.firstName || '');
        setCurrentMiddleName(userData.middleName || '');
        setOriginalMiddleName(userData.middleName || '');
        setCurrentLastName(userData.lastName || '');
        setOriginalLastName(userData.lastName || '');
        setCurrentBio(profile.biography || '');
        setOriginalBio(profile.biography || '');
        setCurrentPhoto(profile.photo || null);
        setCurrentUsername(profile.user_name || '');
        setOriginalUsername(profile.user_name || '');
        setCurrentUrl(profile.url || '');
        setCurrentEmail(userData.email || user.email || '');
    })
    .catch(err => console.error('Error loading profile:', err));
  }, []);

  const handleSavePhoto = async (file) => {
    const reader = new FileReader();
    reader.onloadend = async () => {
        const base64String = reader.result;
        const user = JSON.parse(localStorage.getItem('user'));
        try {
            // Check if profile exists
            let currentProfile = {};
            let profileExists = false;

            try {
                const existing = await axios.get(`/user/${user.id}/profile`);
                // Check if profile exists and has an id (empty object {} means no profile)
                if (existing.data.profile && existing.data.profile.id) {
                    currentProfile = existing.data.profile;
                    profileExists = true;
                }
            } catch (e) {
                profileExists = false;
            }

            const profileData = {
                photo: base64String,
                biography: currentProfile.biography || '',
                userName: currentProfile.user_name || `${user.firstName?.toLowerCase() || 'user'}${user.id?.slice(0, 4) || ''}`,
                url: currentProfile.url || `neuroleap.com/@${currentProfile.user_name || 'user'}`,
            };

            if (profileExists) {
                await axios.put(`/user/${user.id}/profile`, profileData);
            } else {
                await axios.post(`/user/${user.id}/profile`, profileData);
            }

            localStorage.setItem('profileImage', base64String);
            setCurrentPhoto(base64String);
            alert('Profile photo updated!');
            setIsEditingPhoto(false);
        } catch (err) {
            console.error('Error saving photo:', err);
            alert('Failed to save photo');
        }
    };
    reader.readAsDataURL(file);
  };

  const handleSaveName = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setSaving(true);

    try {
      const firstName = currentFirstName.trim();
      const middleName = currentMiddleName.trim();
      const lastName = currentLastName.trim();

      // Update user info
      const response = await axios.put(`/user/${user.id}`, { firstName, middleName, lastName });

      // Update localStorage
      const updatedUser = { ...user, firstName, middleName, lastName };
      localStorage.setItem('user', JSON.stringify(updatedUser));

      setOriginalFirstName(firstName);
      setOriginalMiddleName(middleName);
      setOriginalLastName(lastName);
      setIsEditingName(false);
      alert('Name updated successfully!');
    } catch (err) {
      console.error('Error saving name:', err);
      console.error('Error response:', err.response?.data);
      alert(`Failed to save name: ${err.response?.data?.message || err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveBio = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setSaving(true);

    try {
      // First check if profile exists
      let currentProfile = {};
      let profileExists = false;

      try {
        const existing = await axios.get(`/user/${user.id}/profile`);
        // Check if profile exists and has an id (empty object {} means no profile)
        if (existing.data.profile && existing.data.profile.id) {
          currentProfile = existing.data.profile;
          profileExists = true;
        }
      } catch (e) {
        profileExists = false;
      }

      const profileData = {
        photo: currentProfile.photo || '',
        biography: currentBio,
        userName: currentProfile.user_name || currentUsername || `${user.firstName?.toLowerCase() || 'user'}${user.id?.slice(0, 4) || ''}`,
        url: currentProfile.url || `neuroleap.com/@${currentProfile.user_name || currentUsername || 'user'}`,
      };

      if (profileExists) {
        await axios.put(`/user/${user.id}/profile`, profileData);
      } else {
        await axios.post(`/user/${user.id}/profile`, profileData);
      }

      setOriginalBio(currentBio);
      setIsEditingBio(false);
      alert('Bio updated successfully!');
    } catch (err) {
      console.error('Error saving bio:', err);
      console.error('Error response:', err.response?.data);
      alert(`Failed to save bio: ${err.response?.data?.message || err.message || 'Please try again.'}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveUsername = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    setSaving(true);

    try {
      // Check if profile exists
      let currentProfile = {};
      let profileExists = false;

      try {
        const existing = await axios.get(`/user/${user.id}/profile`);
        // Check if profile exists and has an id (empty object {} means no profile)
        if (existing.data.profile && existing.data.profile.id) {
          currentProfile = existing.data.profile;
          profileExists = true;
        }
      } catch (e) {
        profileExists = false;
      }

      const profileData = {
        photo: currentProfile.photo || '',
        biography: currentProfile.biography || '',
        userName: currentUsername,
        url: `neuroleap.com/@${currentUsername}`,
      };

      if (profileExists) {
        await axios.put(`/user/${user.id}/profile`, profileData);
      } else {
        await axios.post(`/user/${user.id}/profile`, profileData);
      }

      setOriginalUsername(currentUsername);
      setCurrentUrl(`neuroleap.com/@${currentUsername}`);
      setIsEditingUsername(false);
      alert('Username updated successfully!');
    } catch (err) {
      console.error('Error saving username:', err);
      alert(`Failed to save username: ${err.response?.data?.message || err.message || 'Please try again.'}`);
    } finally {
      setSaving(false);
    }
  };

  const handleCancelName = () => {
    setCurrentFirstName(originalFirstName);
    setCurrentMiddleName(originalMiddleName);
    setCurrentLastName(originalLastName);
    setIsEditingName(false);
  };

  const handleCancelBio = () => {
    setCurrentBio(originalBio);
    setIsEditingBio(false);
  };

  const handleCancelUsername = () => {
    setCurrentUsername(originalUsername);
    setIsEditingUsername(false);
  };

  const handleConnectGoogle = () => {
    gapi.auth2.getAuthInstance().signIn().then((response) => {
      const profile = response.getBasicProfile();
      const googleEmail = profile.getEmail();
      const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${googleEmail}`;
      localStorage.setItem('googleProfileLink', mailtoLink);
      setGoogleUser({ name: profile.getName(), email: googleEmail, imageUrl: profile.getImageUrl() });
      alert('Connected to Google successfully!');
    }).catch((error) => {
      console.error('Error connecting to Google:', error);
      alert('Failed to connect to Google.');
    });
  };

  const handleConnectFacebook = () => {
    const facebookProfileLink = 'https://www.facebook.com/profile.php?id=userid';
    localStorage.setItem('facebookProfileLink', facebookProfileLink);
    alert('Connected to Facebook successfully!');
  };

  const handleConnectTwitter = () => {
    const twitterProfileLink = 'https://x.com/link';
    localStorage.setItem('twitterProfileLink', twitterProfileLink);
    alert('Connected to X successfully!');
  };

  const handleConnectLinkedIn = () => {
    const linkedInProfileLink = 'https://www.linkedin.com/in/username';
    localStorage.setItem('linkedInProfileLink', linkedInProfileLink);
    alert('Connected to LinkedIn successfully!');
  };

  const handleConnectThreads = () => {
    const threadsProfileLink = 'https://www.threads.com/@username';
    localStorage.setItem('threadsProfileLink', threadsProfileLink);
    alert('Connected to Threads successfully!');
  };

  const toggleTwitterLink = () => {
    const newValue = !showTwitterLink;
    setShowTwitterLink(newValue);
    localStorage.setItem('showTwitterLink', newValue);
  };

  const toggleLinkedInLink = () => {
    const newValue = !showLinkedInLink;
    setShowLinkedInLink(newValue);
    localStorage.setItem('showLinkedInLink', newValue);
  };

  const toggleThreadsLink = () => {
    const newValue = !showThreadsLink;
    setShowThreadsLink(newValue);
    localStorage.setItem('showThreadsLink', newValue);
  };

  const toggleGoogleLink = () => {
    const newValue = !showGoogleLink;
    setShowGoogleLink(newValue);
    localStorage.setItem('showGoogleLink', newValue);
  };

  const toggleFacebookLink = () => {
    const newValue = !showFacebookLink;
    setShowFacebookLink(newValue);
    localStorage.setItem('showFacebookLink', newValue);
  };

  useEffect(() => {
    const initGoogleAuth = () => {
      gapi.load('auth2', () => {
        gapi.auth2.init({
          client_id: CLIENT_ID,
          scope: API_SCOPE,
        });
      });
    };

    initGoogleAuth();

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v12.0',
      });
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    const storedTwitterLink = localStorage.getItem('showTwitterLink');
    const storedLinkedInLink = localStorage.getItem('showLinkedInLink');
    const storedThreadsLink = localStorage.getItem('showThreadsLink');
    const storedGoogleLink = localStorage.getItem('showGoogleLink');
    const storedFacebookLink = localStorage.getItem('showFacebookLink');

    if (storedTwitterLink !== null) setShowTwitterLink(storedTwitterLink === 'true');
    if (storedLinkedInLink !== null) setShowLinkedInLink(storedLinkedInLink === 'true');
    if (storedThreadsLink !== null) setShowThreadsLink(storedThreadsLink === 'true');
    if (storedGoogleLink !== null) setShowGoogleLink(storedGoogleLink === 'true');
    if (storedFacebookLink !== null) setShowFacebookLink(storedFacebookLink === 'true');
  }, []);

  const handleNavClick = (section) => {
    setActiveSection(section);
  };

  const handleDeactivateAccount = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to deactivate your account? You can reactivate it by signing back in.'
    );
    if (!confirmed) return;

    const user = JSON.parse(localStorage.getItem('user'));
    try {
      await axios.put(`/user/${user.id}/deactivate`);
      alert('Your account has been deactivated.');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/';
    } catch (err) {
      console.error('Error deactivating account:', err);
      alert(`Failed to deactivate account: ${err.response?.data?.message || err.message}`);
    }
  };

  const handleSignOutOtherSessions = async () => {
    const confirmed = window.confirm(
      'This will sign you out of all other browsers and devices. Continue?'
    );
    if (!confirmed) return;

    const user = JSON.parse(localStorage.getItem('user'));
    try {
      const response = await axios.post(`/user/${user.id}/invalidate-sessions`);
      // Update the token with the new one
      if (response.data.token) {
        localStorage.setItem('token', response.data.token.auth);
        if (response.data.token.refresh) {
          localStorage.setItem('refreshToken', response.data.token.refresh);
        }
      }
      alert('All other sessions have been signed out.');
    } catch (err) {
      console.error('Error signing out other sessions:', err);
      alert(`Failed to sign out other sessions: ${err.response?.data?.message || err.message}`);
    }
  };

  const handleDeleteAccount = async () => {
    const confirmed = window.confirm(
      'Are you sure you want to permanently delete your account? This action cannot be undone and all your data will be lost.'
    );
    if (!confirmed) return;

    const doubleConfirmed = window.confirm(
      'This is your final warning. Your account and all associated content will be permanently deleted. Continue?'
    );
    if (!doubleConfirmed) return;

    const user = JSON.parse(localStorage.getItem('user'));
    try {
      await axios.delete(`/user/${user.id}/self`);
      alert('Your account has been permanently deleted.');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/';
    } catch (err) {
      console.error('Error deleting account:', err);
      alert(`Failed to delete account: ${err.response?.data?.message || err.message}`);
    }
  };

  const navItems = [
  { id: 'about', label: t('EditProfilePage.AboutYou') },
  { id: 'design', label: t('EditProfilePage.Design') },
  { id: 'audience', label: t('EditProfilePage.Audience') },
  { id: 'email', label: t('EditProfilePage.EmailSettings') },
  { id: 'connections', label: t('EditProfilePage.Connections') },
  { id: 'account', label: t('EditProfilePage.Account') },
  { id: 'membership', label: t('EditProfilePage.Membership') },
  { id: 'security', label: t('EditProfilePage.Security') },
];

  return (
    <div className="editProfile-container">
      {/* Left Sidebar */}
      <div className="editProfile-left">
        <span className="editProfile-left-title">{t('EditProfilePage.Settings')}</span>
        <nav className="editProfile-left-subbar">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`editProfile-left-subbar-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              {item.label}
            </a>
          ))}
        </nav>
        <hr className="editProfile-left-hr" />
        <div className="editProfile-left-links">
          <a href="/support" className="editProfile-left-links-item">{t("EditProfilePage.Help")}</a>
          <span className="editProfile-left-links-item">{t("EditProfilePage.Privacy")}</span>
          <span className="editProfile-left-links-item">{t("EditProfilePage.Terms")}</span>
          <a href="/about" className="editProfile-left-links-item">{t("About")}</a>
        </div>
      </div>

      {/* Right Content Area */}
      <div className="editProfile-right">
        {/* About You Section */}
        <span id="about" className="editProfile-right-header">About You</span>

        {/* Name Card */}
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">{t("EditProfilePage.Name")}</span>
          {isEditingName ? (
            <div className="editProfile-right-input" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <span className="editProfile-right-label">{t("EditProfilePage.FirstName")}</span>
                <input
                  type="text"
                  value={currentFirstName}
                  onChange={(e) => setCurrentFirstName(e.target.value)}
                  placeholder={t("EditProfilePage.FirstName")}
                  className="editProfile-right-input-item"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <span className="editProfile-right-label">{t("EditProfilePage.MiddleName")}</span>
                <input
                  type="text"
                  value={currentMiddleName}
                  onChange={(e) => setCurrentMiddleName(e.target.value)}
                  placeholder={t("EditProfilePage.MiddleName")}
                  className="editProfile-right-input-item"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <span className="editProfile-right-label">{t("EditProfilePage.LastName")}</span>
                <input
                  type="text"
                  value={currentLastName}
                  onChange={(e) => setCurrentLastName(e.target.value)}
                  placeholder={t("EditProfilePage.LastName")}
                  className="editProfile-right-input-item"
                  style={{ width: '100%', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                <button
                  className="editProfile-right-button"
                  onClick={handleSaveName}
                  disabled={saving}
                >
                  {saving ? 'Saving...' : t("EditProfilePage.Save")}
                </button>
                <button
                  className="editProfile-right-button2"
                  onClick={handleCancelName}
                  disabled={saving}
                >
                  {t("EditProfilePage.Cancel")}
                </button>
              </div>
            </div>
          ) : (
            <>
              <span className="editProfile-right-input">
                {[currentFirstName, currentMiddleName, currentLastName].filter(Boolean).join(' ') || "Not set"}
              </span>
              <p className="editProfile-right-text">
                {t("EditProfilePage.YourNameInfo")}
              </p>
              <button
                onClick={() => setIsEditingName(true)}
                className="editProfile-right-button"
              >
                {t("EditProfilePage.Edit")}
              </button>
            </>
          )}
        </div>

        {/* Bio Card */}
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">{t("EditProfilePage.ShortBio")}</span>
          {isEditingBio ? (
            <div className="editProfile-right-input">
              <textarea
                value={currentBio}
                onChange={(e) => setCurrentBio(e.target.value)}
                placeholder={t("EditProfilePage.ShortBioPlaceholder")}
                className="editProfile-right-input-item"
                maxLength={160}
              />
              <span style={{ fontSize: '0.8rem', color: '#79747E', marginTop: '4px' }}>
                {currentBio.length}/160 characters
              </span>
              <button
                className="editProfile-right-button"
                onClick={handleSaveBio}
                disabled={saving}
              >
                {saving ? 'Saving...' : t("EditProfilePage.Save")}
              </button>
              <button
                className="editProfile-right-button2"
                onClick={handleCancelBio}
                disabled={saving}
              >
                {t("EditProfilePage.Cancel")}
              </button>
            </div>
          ) : (
            <>
              <span className="editProfile-right-input">
                {currentBio || t("EditProfilePage.NoBio")}
              </span>
              <p className="editProfile-right-text">
                {t("EditProfilePage.ShortBioInfo")}
              </p>
              <button
                onClick={() => setIsEditingBio(true)}
                className="editProfile-right-button"
              >
                {t("EditProfilePage.Edit")}
              </button>
            </>
          )}
        </div>

        {/* Photo Card */}
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">{t("EditProfilePage.ProfilePhoto")}</span>
          <div className="editProfile-right-image">
            <img
              src={currentPhoto || "/blogger.jpg"}
              alt="Profile"
              onError={(e) => { e.target.src = "/blogger.jpg"; }}
            />
          </div>
          <p className="editProfile-right-text">
            {t("EditProfilePage.ProfilePhotoInfo")}
          </p>
          {isEditingPhoto ? (
            <div className="editProfile-right-input">
              <input
                type="file"
                accept="image/*"
                className="editProfile-right-input-item"
                onChange={(e) => e.target.files[0] && handleSavePhoto(e.target.files[0])}
              />
              <button
                className="editProfile-right-button2"
                onClick={() => setIsEditingPhoto(false)}
              >
                {t("EditProfilePage.Cancel")}
              </button>
            </div>
          ) : (
            <button className="editProfile-right-button" onClick={handleEditPhoto}>
              {t("EditProfilePage.ChangePhoto")}
            </button>
          )}
        </div>

        {/* Username & URL Card */}
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">{t("EditProfilePage.UsernameURL")}</span>
          {isEditingUsername ? (
            <div className="editProfile-right-input">
              <span className="editProfile-right-label">{t("EditProfilePage.Username")}</span>
              <input
                type="text"
                value={currentUsername}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();
                  setCurrentUsername(value);
                  setCurrentUrl(`neuroleap.com/@${value}`);
                }}
                placeholder="Enter username"
                className="editProfile-right-input-item"
                style={{ marginBottom: '0.5rem' }}
              />
              <span className="editProfile-right-label">{t("EditProfilePage.ProfileURL")}</span>
              <span className="editProfile-right-input" style={{ color: '#79747E' }}>
                neuroleap.com/@{currentUsername || 'username'}
              </span>
              <div style={{ marginTop: '1rem' }}>
                <button
                  className="editProfile-right-button"
                  onClick={handleSaveUsername}
                  disabled={saving}
                >
                  {saving ? 'Saving...' : t("EditProfilePage.Save")}
                </button>
                <button
                  className="editProfile-right-button2"
                  onClick={handleCancelUsername}
                  disabled={saving}
                >
                  {t("EditProfilePage.Cancel")}
                </button>
              </div>
            </div>
          ) : (
            <>
              <span className="editProfile-right-label">{t("EditProfilePage.Username")}</span>
              <span className="editProfile-right-input">@{currentUsername || 'not set'}</span>
              <span className="editProfile-right-label">{t("EditProfilePage.ProfileURL")}</span>
              <span className="editProfile-right-input">
                {currentUsername ? `neuroleap.com/@${currentUsername}` : 'Not set - add a username'}
              </span>
              <button
                className="editProfile-right-button"
                onClick={() => setIsEditingUsername(true)}
              >
                {t("EditProfilePage.Edit")}
              </button>
            </>
          )}
        </div>

        {/* Design Section */}
        <span id="design" className="editProfile-right-header">Design</span>
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Customize Your Profile</span>
          <p className="editProfile-right-text">
            Pick colors and fonts, style the header and make your profile unique.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        {/* Audience Development Section */}
        <span id="audience" className="editProfile-right-header">Audience Development</span>
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Subscription Promotions</span>
          <p className="editProfile-right-text">
            Manage email subscription promotions and reader replies.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Import Subscribers</span>
          <p className="editProfile-right-text">
            Upload a CSV or TXT file containing up to 5,000 email addresses.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Export Subscribers</span>
          <p className="editProfile-right-text">
            Get a list of your subscribers and their emails.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        {/* Email Settings Section */}
        <span id="email" className="editProfile-right-header">Email Settings</span>
        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Your Email</span>
          <span className="editProfile-right-input">{currentEmail || 'No email set'}</span>
          <p className="editProfile-right-text">
            Your email is used for account notifications and recovery.
          </p>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Email Preferences</span>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <div>
              <strong style={{ display: 'block', marginBottom: '4px' }}>NeuroLeap Digest</strong>
              <span className="editProfile-right-text">The best stories personalized for you</span>
            </div>
            <Switch color="primary" defaultChecked />
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <div>
              <strong style={{ display: 'block', marginBottom: '4px' }}>Recommended Reading</strong>
              <span className="editProfile-right-text">Stories based on your reading history</span>
            </div>
            <Switch color="primary" defaultChecked />
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0' }}>
            <div>
              <strong style={{ display: 'block', marginBottom: '4px' }}>Social Notifications</strong>
              <span className="editProfile-right-text">When someone follows you or highlights your work</span>
            </div>
            <Switch color="primary" defaultChecked />
          </div>
        </div>

        {/* Connections Section */}
        <span id="connections" className="editProfile-right-header">Connections</span>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Connect Your Accounts</span>
          <p className="editProfile-right-text">
            Link your social accounts to share your content and grow your audience.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', marginTop: '0.5rem' }}>
            <button className="editProfile-right-button" onClick={handleConnectGoogle}>
              Google
            </button>
            <button className="editProfile-right-button" onClick={handleConnectFacebook}>
              Facebook
            </button>
            <button className="editProfile-right-button" onClick={handleConnectTwitter}>
              X (Twitter)
            </button>
            <button className="editProfile-right-button" onClick={handleConnectLinkedIn}>
              LinkedIn
            </button>
            <button className="editProfile-right-button" onClick={handleConnectThreads}>
              Threads
            </button>
          </div>

          {googleUser && (
            <div className="google-user-info">
              <img src={googleUser.imageUrl} alt="Google" />
              <div>
                <strong>{googleUser.name}</strong>
                <span style={{ display: 'block', fontSize: '0.85rem', color: '#666' }}>{googleUser.email}</span>
              </div>
            </div>
          )}
          {facebookUser && (
            <div className="facebook-user-info">
              <img src={facebookUser.imageUrl} alt="Facebook" />
              <div>
                <strong>{facebookUser.name}</strong>
                <span style={{ display: 'block', fontSize: '0.85rem', color: '#666' }}>{facebookUser.email}</span>
              </div>
            </div>
          )}
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Profile Link Visibility</span>
          <p className="editProfile-right-text">
            Choose which connected accounts appear on your public profile.
          </p>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <span>Show Google link</span>
            <Switch checked={showGoogleLink} onChange={toggleGoogleLink} color="primary" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <span>Show Facebook link</span>
            <Switch checked={showFacebookLink} onChange={toggleFacebookLink} color="primary" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <span>Show X (Twitter) link</span>
            <Switch checked={showTwitterLink} onChange={toggleTwitterLink} color="primary" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <span>Show LinkedIn link</span>
            <Switch checked={showLinkedInLink} onChange={toggleLinkedInLink} color="primary" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0' }}>
            <span>Show Threads link</span>
            <Switch checked={showThreadsLink} onChange={toggleThreadsLink} color="primary" />
          </div>
        </div>

        {/* Account Section */}
        <span id="account" className="editProfile-right-header">Account</span>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Privacy Settings</span>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0.75rem 0', borderBottom: '1px solid #CAC4D0' }}>
            <div>
              <strong style={{ display: 'block', marginBottom: '4px' }}>Allow Private Notes</strong>
              <span className="editProfile-right-text">Readers can leave private notes on your stories</span>
            </div>
            <Switch color="primary" defaultChecked />
          </div>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Manage Muted</span>
          <p className="editProfile-right-text">
            See all publications and authors you've muted.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Blocked Users</span>
          <p className="editProfile-right-text">
            See all users you've blocked.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Download Your Data</span>
          <p className="editProfile-right-text">
            Download a copy of all your information as a .zip file.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        {/* Membership Section */}
        <span id="membership" className="editProfile-right-header">Membership</span>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">NeuroLeap Membership</span>
          <p className="editProfile-right-text">
            Subscribe for unlimited access to all content and exclusive features.
          </p>
          <button className="editProfile-right-button disabled" disabled>Coming Soon</button>
        </div>

        {/* Security Section */}
        <span id="security" className="editProfile-right-header">Security</span>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Active Sessions</span>
          <p className="editProfile-right-text">
            Sign out of all other browsers or devices where you're logged in.
          </p>
          <button className="editProfile-right-button secondary" onClick={handleSignOutOtherSessions}>Sign Out Other Sessions</button>
        </div>

        <div className="editProfile-right-section">
          <span className="editProfile-right-title">Deactivate Account</span>
          <p className="editProfile-right-text">
            Temporarily disable your account. You can reactivate anytime by signing back in.
          </p>
          <button className="editProfile-right-button secondary" onClick={handleDeactivateAccount}>Deactivate</button>
        </div>

        <div className="editProfile-right-section" style={{ borderColor: '#FFDAD6' }}>
          <span className="editProfile-right-title" style={{ color: '#BA1A1A' }}>Delete Account</span>
          <p className="editProfile-right-text">
            Permanently delete your account and all associated content. This action cannot be undone.
          </p>
          <button className="editProfile-right-button danger" onClick={handleDeleteAccount}>Delete Account</button>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
